import { jsx } from "react/jsx-runtime";
import { Icon } from "../MainIcon/MainIcon.js";
import "@mui/material";
const DocumentsFolderIcon = ({ fill = "currentColor", ...rest }) => {
  return /* @__PURE__ */ jsx(Icon, { ...rest, children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M20 6H12.414C12.149 6 11.894 5.895 11.707 5.707L10.293 4.293C10.105 4.105 9.851 4 9.586 4H4C2.895 4 2 4.895 2 6V18C2 19.105 2.895 20 4 20H20C21.105 20 22 19.105 22 18V8C22 6.895 21.105 6 20 6ZM13 9L15 11H13V9ZM9 16.5V9.5C9 9.224 9.224 9 9.5 9H11V12.5C11 12.776 11.224 13 11.5 13H15V16.5C15 16.776 14.776 17 14.5 17H9.5C9.224 17 9 16.776 9 16.5Z",
      fill
    }
  ) });
};
export {
  DocumentsFolderIcon
};
